import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetResolution886ReviewResultsParams {
	report_id: string;
	review_id: string;
	company_id: string;
	organization_id: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886ReviewResults = (params: GetResolution886ReviewResultsParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.report_id, params.review_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_REVIEW_RESULTS, params],
		queryFn: async () => Service.getReviewResult(params),
		enabled: isEnabled
	});
};
